// Tigik i18n — 7 fully-populated languages: SK (default) / EN / CS / DE / PL / RU / UK
export const translations = {
  sk: {
    nav: {
      home: "Domov", orbital: "Orbital", tig: "TIG", ai: "AI Poradca",
      community: "Komunita", pricing: "Môj program",
      login: "Prihlásiť", register: "Registrovať", logout: "Odhlásiť", profile: "Profil",
      pipefitter: "Potrubár", jobs: "Práca", history: "História",
    },
    landing: {
      tag: "Pre profesionálnych zváračov",
      title1: "Presnosť pre", title2: "TIG & orbitálnych zváračov",
      sub: "Kalkulačky parametrov, AI poradca a komunita potrubárov, prípravárov a všetkých, ktorí si chcú vymeniť svoje skúsenosti — všetko na jednom mieste.",
      cta: "Vyskúšať zadarmo", ctaSecondary: "Pozri sa, čo dokážem",
      f1Title: "Orbitálne kalkulačky", f1Desc: "Presné parametre pre Axxair, Orbitec a Orbitalum — prúd, rýchlosť, plyn, čas.",
      f2Title: "Ručný TIG", f2Desc: "Výpočet nastavení pre nerez, oceľ, hliník, titán, meď, duplex.",
      f3Title: "AI Poradca", f3Desc: "Claude Sonnet 4.5 — pýtaj sa na defekty, normy, postupy. Pamätá si rozhovor.",
      f4Title: "Komunita", f4Desc: "Chat pre predplatiteľov: TIG, orbital, potrubári, prípraváry.",
      statsTitle: "Stavané pre prax",
      stat1: "Materiálov", stat1v: "6+", stat2: "Strojov", stat2v: "3",
      stat3: "Kanálov", stat3v: "4", stat4: "Presnosť", stat4v: "±5 %",
      sectionWho: "Komu slúži Tigik",
      personas: ["TIG zvárači", "Orbitálni operátori", "Potrubári", "Prípraváry"],
    },
    auth: {
      loginTitle: "Prihlásenie", registerTitle: "Vytvoriť účet",
      email: "Email", password: "Heslo", name: "Meno",
      submitLogin: "Prihlásiť sa", submitRegister: "Zaregistrovať sa",
      noAccount: "Nemáš účet?", hasAccount: "Už máš účet?",
      orbital: "Pridať sa ku komunite",
    },
    orbital: {
      title: "Orbitálne zváranie — Kalkulačka", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Stroj", material: "Materiál",
      diameter: "Priemer trubky (mm)", wall: "Hrúbka steny (mm)",
      compute: "Vypočítať parametre",
      current: "Základný prúd", speed: "Rýchlosť posuvu", time: "Čas zvaru", rotations: "Rotácie",
      gas: "Ochranný plyn", gasFlow: "Prietok plynu", purge: "Spätný preplach",
      tungsten: "Wolfrámová elektróda", levels: "Sekvenčné úrovne",
      level: "Úroveň", currentA: "Prúd (A)", pulseT: "Pulz (s)", baseT: "Báza (s)",
      waitingCompute: "Čakám na výpočet…",
      highCurrent: "Horný prúd", lowCurrent: "Spodný prúd",
      pulse: "Pulz", base: "Báza", sectorTime: "Čas sektora",
      travel: "Rýchl.", gasPurge: "Plyn / Pur.",
      downSlope: "Down-slope", gasPre: "Plyn vopred", gasPost: "Plyn po",
      exactMatch: "✓ presná zhoda", interpolated: "≈ interpolované",
      confidence: "Spoľahlivosť", sectorsLabel: "sektory",
      fieldTitle: "Reálne programy od používateľov",
      fieldDesc: "Programy pridané používateľmi z reálneho života. Lookup vyberie najbližší program podľa DN + hrúbky a v prípade potreby ho preškáluje.",
      fieldCta: "Nájsť reálny program", fieldSearching: "Hľadám…",
    },
    realprog: {
      title: "Reálne programy",
      sub: "Programy z reálnych zvarov — od komunity, pre komunitu",
      addBtn: "Pridať môj program",
      formTitle: "Pridať reálny program",
      formSub: "Zdieľaj nastavenia, ktoré ti reálne fungujú. Pomôžeš tým ostatným zváračom.",
      materialLbl: "Materiál (napr. Nerez 316L, Duplex, Inconel 625)",
      machineLbl: "Stroj (napr. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Typ hlavy (napr. OW 76, OBA 38, SATF-65)",
      jointLbl: "Typ spoja",
      jointTypes: { pipePipe: "Rúra–Rúra", pipeElbow: "Rúra–Koleno", pipeT: "Rúra–T-kus", pipeReduction: "Rúra–Redukcia", other: "Iné" },
      dnLbl: "Priemer (mm)", wallLbl: "Hrúbka steny (mm)",
      paramsLbl: "Parametre (všetky sektory — viacriadkový text)",
      paramsPh: "Napr.\nSektor 1: HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSektor 2: HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Poznámka (voliteľné)",
      notesPh: "Napr. plyn Ar 99.996, rýchlosť 105 mm/min, predohrev 50 °C…",
      submit: "Uložiť program", cancel: "Zrušiť", saving: "Ukladám…",
      del: "Zmazať", delConfirm: "Naozaj zmazať tento program? Toto sa nedá vrátiť.",
      empty: "Zatiaľ tu nie sú žiadne programy. Buď prvý, kto sa podelí o svoje nastavenia.",
      addedBy: "Pridal", addedAt: "Pridané",
      paywallTitle: "Reálne programy — pre platených členov",
      paywallMsg: "Pre prístup k zdieľaným programom a pridanie vlastných potrebuješ aktívne predplatné (START / ACTIVE / PRO).",
      guestMsg: "Pre prístup k reálnym programom sa najprv registruj a aktivuj predplatné.",
      filterTitle: "Filtre",
      filterMaterialPh: "Materiál…", filterHeadPh: "Typ hlavy…",
      filterDnMin: "DN od", filterDnMax: "DN do",
      clearFilters: "Zrušiť filtre",
      countLabel: "programov",
      requiredErr: "Vyplň všetky povinné polia",
      sortNew: "Najnovšie", sortTop: "Najlepšie",
      upvoteTip: "Toto mi reálne sedlo", upvotedTip: "Zrušiť hodnotenie",
    },
    tig: {
      title: "Ručný TIG — Kalkulačka parametrov", sub: "Presné nastavenie pre rôzne materiály",
      material: "Materiál", thickness: "Hrúbka (mm)", electrode: "Priemer elektródy (mm)",
      compute: "Vypočítať",
      currentRange: "Rozsah prúdu", polarity: "Polarita", gas: "Plyn", gasFlow: "Prietok plynu",
      filler: "Prídavný drôt", fillerDiam: "Priemer drôtu", electrodeType: "Typ elektródy", preheat: "Predohrev",
    },
    ai: {
      title: "AI Poradca", sub: "Claude Sonnet 4.5 — pamätá si rozhovor",
      placeholder: "Spýtaj sa na čokoľvek o zváraní…",
      send: "Odoslať", newChat: "Nová konverzácia", history: "História",
      empty: "Začni novú konverzáciu", thinking: "Premýšľam…",
      suggestions: [
        "Aký prúd nastaviť pre TIG zvar nerez 316 hrúbka 2 mm?",
        "Ako predísť porozite pri zváraní hliníka?",
        "Postup pre orbitálny zvar trubky 50×2 mm",
        "Najčastejšie defekty pri TIG koreňovom zvare",
      ],
    },
    chat: {
      title: "Komunitný chat", sub: "Len pre predplatiteľov",
      channels: "Kanály", placeholder: "Napíš správu…", send: "Odoslať",
      paywallTitle: "Prístup len pre predplatiteľov",
      paywallSub: "Aktivuj Tigik Pro a získaj prístup ku komunitnému chatu.",
      paywallCta: "Zobraziť plány",
      newsReadOnly: "Read only — iba Sauberino(Admin) postuje oznamy. Push notifikáciu dostaneš automaticky.",
      adminOnlyLabel: "ADMIN ONLY",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Potrubári",
        orbital: "Orbitálni zvárači",
        tig: "Ručný TIG",
        prep: "Prípravári",
        others: "Ostatné profesie",
      },
      channelDescs: {
        news: "Oznamy od Sauberino — iba admin postuje, všetci dostanú push notifikáciu",
        pipefitters: "Chat — montáž a príprava potrubí",
        orbital: "Chat — Axxair / Orbitec / Orbitalum",
        tig: "Chat — TIG technika, materiály, defekty",
        prep: "Chat — pomocné a prípravné práce",
        others: "Elektrikári, murári, lešenári, maliari — všetci remeselníci",
      },
    },
    pricing: {
      title: "Vyber si svoj plán",
      sub: "Odomkni komunitný chat, AI poradcu Sauberina a nové funkcie.",
      free: "Free", freeDesc: "Kalkulačky + AI (limit)",
      pro: "Pro", proDesc: "Všetko + komunita + AI 5 správ/deň",
      monthly: "Mesačne", weekly: "Týždenne",
      perMonth: "/mes.", perWeek: "/týž.", subscribe: "Predplatiť",
      currentPlan: "Aktívny plán", paid: "Aktívne predplatné", until: "Platné do", mostPopular: "Najobľúbenejšie",
    },
    jobs: {
      title: "Ponuka práce", sub: "Inzeráty od firiem · 7 € / 7 dní",
      addBtn: "Pridať inzerát · 7 €", empty: "Zatiaľ žiadne inzeráty",
      emptySub: "Buď prvý — pridaj svoj inzerát za 7 € a oslov celú komunitu",
      formTitle: "Pridať pracovný inzerát", formSub: "7 € · viditeľný 7 dní · platba kartou cez Stripe",
      jobTitle: "Názov pozície", company: "Firma", location: "Lokalita",
      desc: "Popis práce", contactEmail: "Kontaktný email", salary: "Plat (voliteľné)",
      jobType: "Typ úväzku", payBtn: "Pokračovať na platbu 7 €",
    },
    profile: { editName: "Uložiť meno", changePw: "Zmeniť heslo", oldPw: "Aktuálne heslo", newPw: "Nové heslo", billingCard: "Fakturačné údaje", billingFill: "Vyplniť", billingEdit: "Upraviť", upgradeCta: "Aktivovať Pro", avatar: "Profilová fotka", avatarUpload: "Nahrať avatar", avatarRemove: "Odstrániť", avatarChange: "Zmeniť avatar" },
    footer: { tag: "Built for welders. By welders." },
        common: {
      compute: "Vypočítať", loading: "Načítavam…", error: "Chyba",
      result: "Výsledok", notes: "Poznámky", units: "Jednotky",
      ready: "Pripravené", live: "LIVE", copy: "Kopírovať",
    },
  },

  en: {
    nav: {
      home: "Home", orbital: "Orbital", tig: "TIG", ai: "AI Advisor",
      community: "Community", pricing: "My Program",
      login: "Login", register: "Sign up", logout: "Logout", profile: "Profile",
      pipefitter: "Pipefitter", jobs: "Jobs", history: "History",
    },
    landing: {
      tag: "For professional welders",
      title1: "Precision for", title2: "TIG & orbital welders",
      sub: "Parameter calculators, AI advisor and a community of pipe fitters — all in one place.",
      cta: "Try for free", ctaSecondary: "See what I can do",
      f1Title: "Orbital calculators", f1Desc: "Accurate parameters for Axxair, Orbitec and Orbitalum — current, speed, gas, time.",
      f2Title: "Manual TIG", f2Desc: "Settings for stainless, carbon steel, aluminum, titanium, copper, duplex.",
      f3Title: "AI Advisor", f3Desc: "Claude Sonnet 4.5 — ask about defects, codes, procedures. It remembers context.",
      f4Title: "Community", f4Desc: "Subscriber chat: TIG, orbital, pipe fitters, fitters.",
      statsTitle: "Built for the shop floor",
      stat1: "Materials", stat1v: "6+", stat2: "Machines", stat2v: "3",
      stat3: "Channels", stat3v: "4", stat4: "Accuracy", stat4v: "±5 %",
      sectionWho: "Who is Tigik for",
      personas: ["TIG welders", "Orbital operators", "Pipe fitters", "Fitters"],
    },
    auth: {
      loginTitle: "Login", registerTitle: "Create account",
      email: "Email", password: "Password", name: "Name",
      submitLogin: "Sign in", submitRegister: "Sign up",
      noAccount: "No account?", hasAccount: "Already have an account?",
      orbital: "Join the community",
    },
    orbital: {
      title: "Orbital welding — Calculator", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Machine", material: "Material",
      diameter: "Pipe diameter (mm)", wall: "Wall thickness (mm)",
      compute: "Compute parameters",
      current: "Base current", speed: "Travel speed", time: "Weld time", rotations: "Rotations",
      gas: "Shielding gas", gasFlow: "Gas flow", purge: "Back purge", tungsten: "Tungsten",
      levels: "Sequence levels",
      level: "Level", currentA: "Current (A)", pulseT: "Pulse (s)", baseT: "Base (s)",
      waitingCompute: "Waiting for compute…",
      highCurrent: "High current", lowCurrent: "Low current",
      pulse: "Pulse", base: "Base", sectorTime: "Sector time",
      travel: "Speed", gasPurge: "Gas / Purge",
      downSlope: "Down-slope", gasPre: "Gas pre", gasPost: "Gas post",
      exactMatch: "✓ exact match", interpolated: "≈ interpolated",
      confidence: "Confidence", sectorsLabel: "sectors",
      fieldTitle: "Real programs from users",
      fieldDesc: "Programs added by users from real welding jobs. The lookup picks the closest match by DN + wall and rescales it if needed.",
      fieldCta: "Find real program", fieldSearching: "Searching…",
    },
    realprog: {
      title: "Real programs",
      sub: "Programs from actual welds — from the community, for the community",
      addBtn: "Add my program",
      formTitle: "Add a real program",
      formSub: "Share settings that actually work for you. Help other welders.",
      materialLbl: "Material (e.g. Stainless 316L, Duplex, Inconel 625)",
      machineLbl: "Machine (e.g. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Head type (e.g. OW 76, OBA 38, SATF-65)",
      jointLbl: "Joint type",
      jointTypes: { pipePipe: "Pipe–Pipe", pipeElbow: "Pipe–Elbow", pipeT: "Pipe–Tee", pipeReduction: "Pipe–Reducer", other: "Other" },
      dnLbl: "Diameter (mm)", wallLbl: "Wall thickness (mm)",
      paramsLbl: "Parameters (all sectors — multi-line)",
      paramsPh: "e.g.\nSector 1: HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSector 2: HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Notes (optional)",
      notesPh: "e.g. Ar 99.996, speed 105 mm/min, preheat 50 °C…",
      submit: "Save program", cancel: "Cancel", saving: "Saving…",
      del: "Delete", delConfirm: "Really delete this program? This cannot be undone.",
      empty: "No programs yet. Be the first to share your setup.",
      addedBy: "Added by", addedAt: "Added",
      paywallTitle: "Real programs — paid members only",
      paywallMsg: "An active subscription (START / ACTIVE / PRO) is required to view and submit shared programs.",
      guestMsg: "Sign up and activate a subscription to access real programs.",
      filterTitle: "Filters",
      filterMaterialPh: "Material…", filterHeadPh: "Head type…",
      filterDnMin: "DN from", filterDnMax: "DN to",
      clearFilters: "Clear filters",
      countLabel: "programs",
      requiredErr: "Please fill in all required fields",
      sortNew: "Newest", sortTop: "Top voted",
      upvoteTip: "This actually worked for me", upvotedTip: "Remove vote",
    },
    tig: {
      title: "Manual TIG — Parameter calculator", sub: "Precise settings for various materials",
      material: "Material", thickness: "Thickness (mm)", electrode: "Electrode diameter (mm)",
      compute: "Compute",
      currentRange: "Current range", polarity: "Polarity",
      gas: "Gas", gasFlow: "Gas flow", filler: "Filler wire",
      fillerDiam: "Wire diameter", electrodeType: "Electrode type", preheat: "Preheat",
    },
    ai: {
      title: "AI Advisor", sub: "Claude Sonnet 4.5 — remembers context",
      placeholder: "Ask anything about welding…",
      send: "Send", newChat: "New chat", history: "History",
      empty: "Start a new conversation", thinking: "Thinking…",
      suggestions: [
        "What current to set for TIG welding 316 stainless 2 mm?",
        "How to prevent porosity when welding aluminium?",
        "Procedure for orbital welding 50×2 mm tube",
        "Most common defects in TIG root pass",
      ],
    },
    chat: {
      title: "Community chat", sub: "Subscribers only",
      channels: "Channels", placeholder: "Type a message…", send: "Send",
      paywallTitle: "Subscribers only",
      paywallSub: "Activate Tigik Pro to access the community chat.",
      paywallCta: "See plans",
      newsReadOnly: "Read only — only Sauberino(Admin) posts announcements. You'll get a push notification automatically.",
      adminOnlyLabel: "ADMIN ONLY",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Pipefitters",
        orbital: "Orbital welders",
        tig: "Manual TIG",
        prep: "Preppers",
        others: "Other trades",
      },
      channelDescs: {
        news: "Announcements from Sauberino — admin posts only, everyone gets a push notification",
        pipefitters: "Chat — pipe assembly and preparation",
        orbital: "Chat — Axxair / Orbitec / Orbitalum",
        tig: "Chat — TIG technique, materials, defects",
        prep: "Chat — auxiliary and prep work",
        others: "Electricians, masons, scaffolders, painters — all trades",
      },
    },
    pricing: {
      title: "Pick your plan",
      sub: "Unlock community chat, the AI advisor Sauberino and new features.",
      free: "Free", freeDesc: "Calculators + AI (limited)",
      pro: "Pro", proDesc: "Everything + community + AI 5 messages/day",
      monthly: "Monthly", weekly: "Weekly",
      perMonth: "/mo", perWeek: "/wk", subscribe: "Subscribe",
      currentPlan: "Current plan", paid: "Active subscription", until: "Active until", mostPopular: "Most popular",
    },
    jobs: {
      title: "Jobs Board", sub: "Job ads · 7 € / 7 days",
      addBtn: "Post a job · 7 €", empty: "No jobs yet",
      emptySub: "Be the first — post yours for 7 € and reach the whole community",
      formTitle: "Post a job ad", formSub: "7 € · visible 7 days · card payment via Stripe",
      jobTitle: "Job title", company: "Company", location: "Location",
      desc: "Job description", contactEmail: "Contact email", salary: "Salary (optional)",
      jobType: "Employment type", payBtn: "Continue to payment 7 €",
    },
    profile: { editName: "Save name", changePw: "Change password", oldPw: "Current password", newPw: "New password", billingCard: "Billing details", billingFill: "Fill in", billingEdit: "Edit", upgradeCta: "Activate Pro", avatar: "Profile picture", avatarUpload: "Upload avatar", avatarRemove: "Remove", avatarChange: "Change avatar" },
    footer: { tag: "Built for welders. By welders." },
        common: {
      compute: "Compute", loading: "Loading…", error: "Error",
      result: "Result", notes: "Notes", units: "Units",
      ready: "Ready", live: "LIVE", copy: "Copy",
    },
  },

  cs: {
    nav: {
      home: "Domů", orbital: "Orbital", tig: "TIG", ai: "AI Poradce",
      community: "Komunita", pricing: "Můj program",
      login: "Přihlásit", register: "Registrovat", logout: "Odhlásit", profile: "Profil",
      pipefitter: "Potrubář", jobs: "Práce", history: "Historie",
    },
    landing: {
      tag: "Pro profesionální svářeče",
      title1: "Přesnost pro", title2: "TIG & orbitální svářeče",
      sub: "Kalkulačky parametrů, AI poradce a komunita potrubářů a přípravářů — vše na jednom místě.",
      cta: "Vyzkoušet zdarma", ctaSecondary: "Podívej se, co umím",
      f1Title: "Orbitální kalkulačky", f1Desc: "Přesné parametry pro Axxair, Orbitec a Orbitalum — proud, rychlost, plyn, čas.",
      f2Title: "Ruční TIG", f2Desc: "Výpočet nastavení pro nerez, ocel, hliník, titan, měď, duplex.",
      f3Title: "AI Poradce", f3Desc: "Claude Sonnet 4.5 — ptejte se na vady, normy, postupy. Pamatuje si rozhovor.",
      f4Title: "Komunita", f4Desc: "Chat pro předplatitele: TIG, orbital, potrubáři, přípraváři.",
      statsTitle: "Postaveno pro dílnu",
      stat1: "Materiálů", stat1v: "6+", stat2: "Strojů", stat2v: "3",
      stat3: "Kanálů", stat3v: "4", stat4: "Přesnost", stat4v: "±5 %",
      sectionWho: "Pro koho je Tigik",
      personas: ["TIG svářeči", "Orbitální operátoři", "Potrubáři", "Přípraváři"],
    },
    auth: {
      loginTitle: "Přihlášení", registerTitle: "Vytvořit účet",
      email: "Email", password: "Heslo", name: "Jméno",
      submitLogin: "Přihlásit se", submitRegister: "Zaregistrovat se",
      noAccount: "Nemáš účet?", hasAccount: "Už máš účet?",
      orbital: "Přidat se ke komunitě",
    },
    orbital: {
      title: "Orbitální svařování — Kalkulačka", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Stroj", material: "Materiál",
      diameter: "Průměr trubky (mm)", wall: "Tloušťka stěny (mm)",
      compute: "Vypočítat parametry",
      current: "Základní proud", speed: "Rychlost posuvu", time: "Čas svaru", rotations: "Rotace",
      gas: "Ochranný plyn", gasFlow: "Průtok plynu", purge: "Zpětný proplach",
      tungsten: "Wolframová elektroda", levels: "Sekvenční úrovně",
      level: "Úroveň", currentA: "Proud (A)", pulseT: "Pulz (s)", baseT: "Báze (s)",
      waitingCompute: "Čekám na výpočet…",
      highCurrent: "Horní proud", lowCurrent: "Spodní proud",
      pulse: "Pulz", base: "Báze", sectorTime: "Čas sektoru",
      travel: "Rychl.", gasPurge: "Plyn / Pur.",
      downSlope: "Down-slope", gasPre: "Plyn předem", gasPost: "Plyn po",
      exactMatch: "✓ přesná shoda", interpolated: "≈ interpolováno",
      confidence: "Spolehlivost", sectorsLabel: "sektory",
      fieldTitle: "Reálné programy od uživatelů",
      fieldDesc: "Programy přidané uživateli z reálných svárů. Lookup vybere nejbližší program podle DN + tloušťky a v případě potřeby ho přeškáluje.",
      fieldCta: "Najít reálný program", fieldSearching: "Hledám…",
    },
    realprog: {
      title: "Reálné programy",
      sub: "Programy z reálných svárů — od komunity, pro komunitu",
      addBtn: "Přidat můj program",
      formTitle: "Přidat reálný program",
      formSub: "Sdílej nastavení, která ti reálně fungují. Pomůžeš tím ostatním svářečům.",
      materialLbl: "Materiál (např. Nerez 316L, Duplex, Inconel 625)",
      machineLbl: "Stroj (např. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Typ hlavy (např. OW 76, OBA 38, SATF-65)",
      jointLbl: "Typ spoje",
      jointTypes: { pipePipe: "Trubka–Trubka", pipeElbow: "Trubka–Koleno", pipeT: "Trubka–T-kus", pipeReduction: "Trubka–Redukce", other: "Jiné" },
      dnLbl: "Průměr (mm)", wallLbl: "Tloušťka stěny (mm)",
      paramsLbl: "Parametry (všechny sektory — víceřádkový text)",
      paramsPh: "Např.\nSektor 1: HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSektor 2: HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Poznámka (volitelné)",
      notesPh: "Např. plyn Ar 99.996, rychlost 105 mm/min, předehřev 50 °C…",
      submit: "Uložit program", cancel: "Zrušit", saving: "Ukládám…",
      del: "Smazat", delConfirm: "Opravdu smazat tento program? Toto nelze vrátit.",
      empty: "Zatím tu nejsou žádné programy. Buď první, kdo se podělí o své nastavení.",
      addedBy: "Přidal", addedAt: "Přidáno",
      paywallTitle: "Reálné programy — pro platící členy",
      paywallMsg: "Pro přístup ke sdíleným programům a přidání vlastních potřebuješ aktivní předplatné (START / ACTIVE / PRO).",
      guestMsg: "Pro přístup k reálným programům se nejdřív registruj a aktivuj předplatné.",
      filterTitle: "Filtry",
      filterMaterialPh: "Materiál…", filterHeadPh: "Typ hlavy…",
      filterDnMin: "DN od", filterDnMax: "DN do",
      clearFilters: "Zrušit filtry",
      countLabel: "programů",
      requiredErr: "Vyplň všechna povinná pole",
      sortNew: "Nejnovější", sortTop: "Nejlepší",
      upvoteTip: "Tohle mi reálně sedlo", upvotedTip: "Zrušit hodnocení",
    },
    tig: {
      title: "Ruční TIG — Kalkulačka parametrů", sub: "Přesné nastavení pro různé materiály",
      material: "Materiál", thickness: "Tloušťka (mm)", electrode: "Průměr elektrody (mm)",
      compute: "Vypočítat",
      currentRange: "Rozsah proudu", polarity: "Polarita", gas: "Plyn", gasFlow: "Průtok plynu",
      filler: "Přídavný drát", fillerDiam: "Průměr drátu", electrodeType: "Typ elektrody", preheat: "Předehřev",
    },
    ai: {
      title: "AI Poradce", sub: "Claude Sonnet 4.5 — pamatuje si rozhovor",
      placeholder: "Zeptejte se na cokoli o svařování…",
      send: "Odeslat", newChat: "Nová konverzace", history: "Historie",
      empty: "Začněte novou konverzaci", thinking: "Přemýšlím…",
      suggestions: [
        "Jaký proud nastavit pro TIG svar nerez 316 tloušťka 2 mm?",
        "Jak předejít pórovitosti při svařování hliníku?",
        "Postup pro orbitální svar trubky 50×2 mm",
        "Nejčastější vady u TIG kořenového svaru",
      ],
    },
    chat: {
      title: "Komunitní chat", sub: "Pouze pro předplatitele",
      channels: "Kanály", placeholder: "Napište zprávu…", send: "Odeslat",
      paywallTitle: "Pouze pro předplatitele",
      paywallSub: "Aktivujte Tigik Pro pro přístup ke komunitnímu chatu.",
      paywallCta: "Zobrazit plány",
      newsReadOnly: "Read only — jen Sauberino(Admin) přidává oznámení. Push notifikaci dostanete automaticky.",
      adminOnlyLabel: "JEN ADMIN",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Potrubáři",
        orbital: "Orbitální svářeči",
        tig: "Ruční TIG",
        prep: "Přípraváři",
        others: "Ostatní profese",
      },
      channelDescs: {
        news: "Oznámení od Sauberino — pouze admin přidává příspěvky, všichni dostanou push notifikaci",
        pipefitters: "Chat — montáž a příprava potrubí",
        orbital: "Chat — Axxair / Orbitec / Orbitalum",
        tig: "Chat — TIG technika, materiály, vady",
        prep: "Chat — pomocné a přípravné práce",
        others: "Elektrikáři, zedníci, lešenáři, malíři — všichni řemeslníci",
      },
    },
    pricing: {
      title: "Vyber si svůj plán",
      sub: "Odemkni komunitní chat, AI poradce Sauberina a nové funkce.",
      free: "Free", freeDesc: "Kalkulačky + AI (limit)",
      pro: "Pro", proDesc: "Vše + komunita + AI 5 zpráv/den",
      monthly: "Měsíčně", weekly: "Týdně",
      perMonth: "/měs.", perWeek: "/týd.", subscribe: "Předplatit",
      currentPlan: "Aktivní plán", paid: "Aktivní předplatné", until: "Platné do", mostPopular: "Nejoblíbenější",
    },
    jobs: {
      title: "Nabídka práce", sub: "Inzeráty od firem · 7 € / 7 dní",
      addBtn: "Přidat inzerát · 7 €", empty: "Zatím žádné inzeráty",
      emptySub: "Buď první — přidej svůj inzerát za 7 € a oslov celou komunitu",
      formTitle: "Přidat pracovní inzerát", formSub: "7 € · viditelný 7 dní · platba kartou přes Stripe",
      jobTitle: "Název pozice", company: "Firma", location: "Lokalita",
      desc: "Popis práce", contactEmail: "Kontaktní email", salary: "Plat (volitelné)",
      jobType: "Typ úvazku", payBtn: "Pokračovat na platbu 7 €",
    },
    profile: { editName: "Uložit jméno", changePw: "Změnit heslo", oldPw: "Aktuální heslo", newPw: "Nové heslo", billingCard: "Fakturační údaje", billingFill: "Vyplnit", billingEdit: "Upravit", upgradeCta: "Aktivovat Pro", avatar: "Profilová fotka", avatarUpload: "Nahrát avatar", avatarRemove: "Odstranit", avatarChange: "Změnit avatar" },
    footer: { tag: "Postaveno pro svářeče. Svářeči." },
        common: {
      compute: "Vypočítat", loading: "Načítám…", error: "Chyba",
      result: "Výsledek", notes: "Poznámky", units: "Jednotky",
      ready: "Připraveno", live: "LIVE", copy: "Kopírovat",
    },
  },

  de: {
    nav: {
      home: "Start", orbital: "Orbital", tig: "WIG", ai: "KI-Berater",
      community: "Community", pricing: "Mein Programm",
      login: "Anmelden", register: "Registrieren", logout: "Abmelden", profile: "Profil",
      pipefitter: "Rohrleger", jobs: "Jobs", history: "Verlauf",
    },
    landing: {
      tag: "Für professionelle Schweißer",
      title1: "Präzision für", title2: "WIG- & Orbital-Schweißer",
      sub: "Parameterrechner, KI-Berater und eine Community von Rohrlegern und Vorbereitern — alles an einem Ort.",
      cta: "Kostenlos testen", ctaSecondary: "Sieh, was ich kann",
      f1Title: "Orbital-Rechner", f1Desc: "Genaue Parameter für Axxair, Orbitec und Orbitalum — Strom, Geschwindigkeit, Gas, Zeit.",
      f2Title: "Manuelles WIG", f2Desc: "Einstellungen für Edelstahl, Stahl, Aluminium, Titan, Kupfer, Duplex.",
      f3Title: "KI-Berater", f3Desc: "Claude Sonnet 4.5 — fragen Sie zu Fehlern, Normen, Verfahren. Erinnert sich an den Verlauf.",
      f4Title: "Community", f4Desc: "Abonnenten-Chat: WIG, Orbital, Rohrleger, Vorbereiter.",
      statsTitle: "Für die Werkstatt gebaut",
      stat1: "Materialien", stat1v: "6+", stat2: "Maschinen", stat2v: "3",
      stat3: "Kanäle", stat3v: "4", stat4: "Genauigkeit", stat4v: "±5 %",
      sectionWho: "Für wen ist Tigik",
      personas: ["WIG-Schweißer", "Orbital-Operatoren", "Rohrleger", "Vorbereiter"],
    },
    auth: {
      loginTitle: "Anmeldung", registerTitle: "Konto erstellen",
      email: "E-Mail", password: "Passwort", name: "Name",
      submitLogin: "Anmelden", submitRegister: "Registrieren",
      noAccount: "Noch kein Konto?", hasAccount: "Bereits ein Konto?",
      orbital: "Der Community beitreten",
    },
    orbital: {
      title: "Orbital-Schweißen — Rechner", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Maschine", material: "Material",
      diameter: "Rohrdurchmesser (mm)", wall: "Wandstärke (mm)",
      compute: "Parameter berechnen",
      current: "Grundstrom", speed: "Vorschubgeschwindigkeit", time: "Schweißzeit", rotations: "Umdrehungen",
      gas: "Schutzgas", gasFlow: "Gasdurchfluss", purge: "Rückspülung",
      tungsten: "Wolframelektrode", levels: "Sequenz-Stufen",
      level: "Stufe", currentA: "Strom (A)", pulseT: "Puls (s)", baseT: "Basis (s)",
      waitingCompute: "Warte auf Berechnung…",
      highCurrent: "Höherer Strom", lowCurrent: "Niedrigerer Strom",
      pulse: "Puls", base: "Basis", sectorTime: "Sektorzeit",
      travel: "Geschw.", gasPurge: "Gas / Spül.",
      downSlope: "Down-slope", gasPre: "Gas vor", gasPost: "Gas nach",
      exactMatch: "✓ genaue Übereinstimmung", interpolated: "≈ interpoliert",
      confidence: "Zuverlässigkeit", sectorsLabel: "Sektoren",
      fieldTitle: "Echte Programme von Nutzern",
      fieldDesc: "Programme von Nutzern aus realen Schweißarbeiten. Die Suche wählt den nächsten Treffer nach DN + Wandstärke und skaliert ihn bei Bedarf um.",
      fieldCta: "Echtes Programm finden", fieldSearching: "Suche…",
    },
    realprog: {
      title: "Echte Programme",
      sub: "Programme aus echten Schweißarbeiten — von der Community, für die Community",
      addBtn: "Mein Programm hinzufügen",
      formTitle: "Echtes Programm hinzufügen",
      formSub: "Teile Einstellungen, die bei dir wirklich funktionieren. Hilf anderen Schweißern.",
      materialLbl: "Material (z. B. Edelstahl 316L, Duplex, Inconel 625)",
      machineLbl: "Maschine (z. B. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Kopftyp (z. B. OW 76, OBA 38, SATF-65)",
      jointLbl: "Verbindungstyp",
      jointTypes: { pipePipe: "Rohr–Rohr", pipeElbow: "Rohr–Bogen", pipeT: "Rohr–T-Stück", pipeReduction: "Rohr–Reduzierung", other: "Sonstiges" },
      dnLbl: "Durchmesser (mm)", wallLbl: "Wandstärke (mm)",
      paramsLbl: "Parameter (alle Sektoren — mehrzeilig)",
      paramsPh: "z. B.\nSektor 1: HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSektor 2: HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Notiz (optional)",
      notesPh: "z. B. Ar 99.996, Geschwindigkeit 105 mm/min, Vorwärmung 50 °C…",
      submit: "Programm speichern", cancel: "Abbrechen", saving: "Speichere…",
      del: "Löschen", delConfirm: "Dieses Programm wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
      empty: "Noch keine Programme. Sei der Erste und teile deine Einstellungen.",
      addedBy: "Hinzugefügt von", addedAt: "Hinzugefügt",
      paywallTitle: "Echte Programme — nur für zahlende Mitglieder",
      paywallMsg: "Für den Zugriff auf geteilte Programme und eigene Einträge wird ein aktives Abo (START / ACTIVE / PRO) benötigt.",
      guestMsg: "Registriere dich und aktiviere ein Abo, um echte Programme zu sehen.",
      filterTitle: "Filter",
      filterMaterialPh: "Material…", filterHeadPh: "Kopftyp…",
      filterDnMin: "DN von", filterDnMax: "DN bis",
      clearFilters: "Filter zurücksetzen",
      countLabel: "Programme",
      requiredErr: "Bitte alle Pflichtfelder ausfüllen",
      sortNew: "Neueste", sortTop: "Top bewertet",
      upvoteTip: "Hat bei mir wirklich funktioniert", upvotedTip: "Bewertung entfernen",
    },
    tig: {
      title: "Manuelles WIG — Parameter-Rechner", sub: "Präzise Einstellungen für verschiedene Materialien",
      material: "Material", thickness: "Dicke (mm)", electrode: "Elektrodendurchmesser (mm)",
      compute: "Berechnen",
      currentRange: "Strombereich", polarity: "Polarität", gas: "Gas", gasFlow: "Gasdurchfluss",
      filler: "Zusatzdraht", fillerDiam: "Drahtdurchmesser", electrodeType: "Elektrodentyp", preheat: "Vorwärmung",
    },
    ai: {
      title: "KI-Berater", sub: "Claude Sonnet 4.5 — merkt sich den Verlauf",
      placeholder: "Fragen Sie alles zum Schweißen…",
      send: "Senden", newChat: "Neuer Chat", history: "Verlauf",
      empty: "Starten Sie eine neue Konversation", thinking: "Denke nach…",
      suggestions: [
        "Welche Stromstärke für WIG-Schweißen Edelstahl 316 mit 2 mm?",
        "Wie vermeide ich Porosität beim Aluminium-Schweißen?",
        "Vorgehensweise für Orbital-Schweißung Rohr 50×2 mm",
        "Häufigste Fehler bei der WIG-Wurzellage",
      ],
    },
    chat: {
      title: "Community-Chat", sub: "Nur für Abonnenten",
      channels: "Kanäle", placeholder: "Nachricht schreiben…", send: "Senden",
      paywallTitle: "Nur für Abonnenten",
      paywallSub: "Aktiviere Tigik Pro für den Zugriff auf den Community-Chat.",
      paywallCta: "Pläne anzeigen",
      newsReadOnly: "Schreibgeschützt — nur Sauberino(Admin) postet Ankündigungen. Du erhältst automatisch eine Push-Benachrichtigung.",
      adminOnlyLabel: "NUR ADMIN",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Rohrleger",
        orbital: "Orbital-Schweißer",
        tig: "Manuelles WIG",
        prep: "Vorbereiter",
        others: "Andere Berufe",
      },
      channelDescs: {
        news: "Ankündigungen von Sauberino — nur Admin postet, alle erhalten eine Push-Benachrichtigung",
        pipefitters: "Chat — Rohrmontage und Vorbereitung",
        orbital: "Chat — Axxair / Orbitec / Orbitalum",
        tig: "Chat — WIG-Technik, Materialien, Fehler",
        prep: "Chat — Hilfs- und Vorbereitungsarbeiten",
        others: "Elektriker, Maurer, Gerüstbauer, Maler — alle Handwerker",
      },
    },
    pricing: {
      title: "Wähle deinen Plan",
      sub: "Schalte den Community-Chat, den KI-Berater Sauberino und neue Funktionen frei.",
      free: "Free", freeDesc: "Rechner + KI (begrenzt)",
      pro: "Pro", proDesc: "Alles + Community + KI 5 Nachrichten/Tag",
      monthly: "Monatlich", weekly: "Wöchentlich",
      perMonth: "/Mon.", perWeek: "/Wo.", subscribe: "Abonnieren",
      currentPlan: "Aktiver Plan", paid: "Aktives Abo", until: "Gültig bis", mostPopular: "Beliebteste",
    },
    jobs: {
      title: "Stellenangebote", sub: "Anzeigen von Firmen · 7 € / 7 Tage",
      addBtn: "Anzeige aufgeben · 7 €", empty: "Noch keine Anzeigen",
      emptySub: "Sei der Erste — gib deine Anzeige für 7 € auf und erreiche die ganze Community",
      formTitle: "Stellenanzeige aufgeben", formSub: "7 € · 7 Tage sichtbar · Kartenzahlung über Stripe",
      jobTitle: "Stellenbezeichnung", company: "Firma", location: "Standort",
      desc: "Stellenbeschreibung", contactEmail: "Kontakt-E-Mail", salary: "Gehalt (optional)",
      jobType: "Beschäftigungsart", payBtn: "Weiter zur Zahlung 7 €",
    },
    profile: { editName: "Name speichern", changePw: "Passwort ändern", oldPw: "Aktuelles Passwort", newPw: "Neues Passwort", billingCard: "Rechnungsdaten", billingFill: "Ausfüllen", billingEdit: "Bearbeiten", upgradeCta: "Pro aktivieren", avatar: "Profilbild", avatarUpload: "Avatar hochladen", avatarRemove: "Entfernen", avatarChange: "Avatar ändern" },
    footer: { tag: "Von Schweißern. Für Schweißer." },
        common: {
      compute: "Berechnen", loading: "Lade…", error: "Fehler",
      result: "Ergebnis", notes: "Notizen", units: "Einheiten",
      ready: "Bereit", live: "LIVE", copy: "Kopieren",
    },
  },

  pl: {
    nav: {
      home: "Start", orbital: "Orbital", tig: "TIG", ai: "Doradca AI",
      community: "Społeczność", pricing: "Mój program",
      login: "Zaloguj", register: "Rejestracja", logout: "Wyloguj", profile: "Profil",
      pipefitter: "Rurociągi", jobs: "Praca", history: "Historia",
    },
    landing: {
      tag: "Dla profesjonalnych spawaczy",
      title1: "Precyzja dla", title2: "spawaczy TIG i orbitalnych",
      sub: "Kalkulatory parametrów, doradca AI i społeczność rurociągowców — wszystko w jednym miejscu.",
      cta: "Wypróbuj za darmo", ctaSecondary: "Zobacz, co potrafię",
      f1Title: "Kalkulatory orbitalne", f1Desc: "Dokładne parametry dla Axxair, Orbitec i Orbitalum — prąd, prędkość, gaz, czas.",
      f2Title: "Ręczny TIG", f2Desc: "Ustawienia dla stali nierdzewnej, węglowej, aluminium, tytanu, miedzi, duplex.",
      f3Title: "Doradca AI", f3Desc: "Claude Sonnet 4.5 — pytaj o wady, normy, procedury. Pamięta rozmowę.",
      f4Title: "Społeczność", f4Desc: "Czat dla subskrybentów: TIG, orbital, rurociągi, przygotowanie.",
      statsTitle: "Stworzone dla warsztatu",
      stat1: "Materiały", stat1v: "6+", stat2: "Maszyny", stat2v: "3",
      stat3: "Kanały", stat3v: "4", stat4: "Dokładność", stat4v: "±5 %",
      sectionWho: "Dla kogo jest Tigik",
      personas: ["Spawacze TIG", "Operatorzy orbitalni", "Rurociągowcy", "Przygotowanie"],
    },
    auth: {
      loginTitle: "Logowanie", registerTitle: "Utwórz konto",
      email: "Email", password: "Hasło", name: "Imię",
      submitLogin: "Zaloguj się", submitRegister: "Zarejestruj się",
      noAccount: "Nie masz konta?", hasAccount: "Masz już konto?",
      orbital: "Dołącz do społeczności",
    },
    orbital: {
      title: "Spawanie orbitalne — Kalkulator", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Maszyna", material: "Materiał",
      diameter: "Średnica rury (mm)", wall: "Grubość ścianki (mm)",
      compute: "Oblicz parametry",
      current: "Prąd bazowy", speed: "Prędkość posuwu", time: "Czas spoiny", rotations: "Obroty",
      gas: "Gaz osłonowy", gasFlow: "Przepływ gazu", purge: "Płukanie powrotne",
      tungsten: "Elektroda wolframowa", levels: "Poziomy sekwencji",
      level: "Poziom", currentA: "Prąd (A)", pulseT: "Impuls (s)", baseT: "Baza (s)",
      waitingCompute: "Czekam na obliczenia…",
      highCurrent: "Prąd górny", lowCurrent: "Prąd dolny",
      pulse: "Impuls", base: "Baza", sectorTime: "Czas sektora",
      travel: "Prędk.", gasPurge: "Gaz / Płuk.",
      downSlope: "Down-slope", gasPre: "Gaz pre", gasPost: "Gaz post",
      exactMatch: "✓ dokładne dopasowanie", interpolated: "≈ interpolowane",
      confidence: "Pewność", sectorsLabel: "sektory",
      fieldTitle: "Realne programy od użytkowników",
      fieldDesc: "Programy dodane przez użytkowników z prawdziwych spoin. Wyszukiwanie wybiera najbliższy program według DN + grubości i w razie potrzeby skaluje go.",
      fieldCta: "Znajdź realny program", fieldSearching: "Szukam…",
    },
    realprog: {
      title: "Realne programy",
      sub: "Programy z prawdziwych spoin — od społeczności, dla społeczności",
      addBtn: "Dodaj mój program",
      formTitle: "Dodaj realny program",
      formSub: "Podziel się ustawieniami, które naprawdę u Ciebie działają. Pomożesz innym spawaczom.",
      materialLbl: "Materiał (np. Nierdzewna 316L, Duplex, Inconel 625)",
      machineLbl: "Maszyna (np. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Typ głowicy (np. OW 76, OBA 38, SATF-65)",
      jointLbl: "Typ połączenia",
      jointTypes: { pipePipe: "Rura–Rura", pipeElbow: "Rura–Kolano", pipeT: "Rura–Trójnik", pipeReduction: "Rura–Reduktor", other: "Inne" },
      dnLbl: "Średnica (mm)", wallLbl: "Grubość ścianki (mm)",
      paramsLbl: "Parametry (wszystkie sektory — wielowierszowy tekst)",
      paramsPh: "Np.\nSektor 1: HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSektor 2: HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Notatka (opcjonalnie)",
      notesPh: "Np. gaz Ar 99.996, prędkość 105 mm/min, podgrzew 50 °C…",
      submit: "Zapisz program", cancel: "Anuluj", saving: "Zapisuję…",
      del: "Usuń", delConfirm: "Na pewno usunąć ten program? Tego nie można cofnąć.",
      empty: "Brak programów. Bądź pierwszy i podziel się swoimi ustawieniami.",
      addedBy: "Dodał", addedAt: "Dodano",
      paywallTitle: "Realne programy — dla płatnych członków",
      paywallMsg: "Aby przeglądać i dodawać udostępnione programy, potrzebna jest aktywna subskrypcja (START / ACTIVE / PRO).",
      guestMsg: "Zarejestruj się i aktywuj subskrypcję, aby uzyskać dostęp do realnych programów.",
      filterTitle: "Filtry",
      filterMaterialPh: "Materiał…", filterHeadPh: "Typ głowicy…",
      filterDnMin: "DN od", filterDnMax: "DN do",
      clearFilters: "Wyczyść filtry",
      countLabel: "programów",
      requiredErr: "Wypełnij wszystkie wymagane pola",
      sortNew: "Najnowsze", sortTop: "Najlepiej oceniane",
      upvoteTip: "U mnie naprawdę zadziałało", upvotedTip: "Usuń ocenę",
    },
    tig: {
      title: "Ręczny TIG — Kalkulator parametrów", sub: "Precyzyjne ustawienia dla różnych materiałów",
      material: "Materiał", thickness: "Grubość (mm)", electrode: "Średnica elektrody (mm)",
      compute: "Oblicz",
      currentRange: "Zakres prądu", polarity: "Polaryzacja", gas: "Gaz", gasFlow: "Przepływ gazu",
      filler: "Drut dodatkowy", fillerDiam: "Średnica drutu", electrodeType: "Typ elektrody", preheat: "Podgrzewanie",
    },
    ai: {
      title: "Doradca AI", sub: "Claude Sonnet 4.5 — pamięta rozmowę",
      placeholder: "Zapytaj o cokolwiek związanego ze spawaniem…",
      send: "Wyślij", newChat: "Nowa rozmowa", history: "Historia",
      empty: "Rozpocznij nową rozmowę", thinking: "Myślę…",
      suggestions: [
        "Jaki prąd ustawić do spawania TIG nierdzewki 316 grubość 2 mm?",
        "Jak zapobiec porowatości przy spawaniu aluminium?",
        "Procedura spawania orbitalnego rury 50×2 mm",
        "Najczęstsze wady przy TIG spoinie graniowej",
      ],
    },
    chat: {
      title: "Czat społeczności", sub: "Tylko dla subskrybentów",
      channels: "Kanały", placeholder: "Wpisz wiadomość…", send: "Wyślij",
      paywallTitle: "Tylko dla subskrybentów",
      paywallSub: "Aktywuj Tigik Pro, aby uzyskać dostęp do czatu społeczności.",
      paywallCta: "Pokaż plany",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Rurociągowcy",
        orbital: "Spawacze orbitalni",
        tig: "Ręczny TIG",
        prep: "Przygotowywacze",
        others: "Inne zawody",
      },
      channelDescs: {
        news: "Ogłoszenia od Sauberino — tylko admin może publikować, każdy otrzyma powiadomienie push",
        pipefitters: "Czat — montaż i przygotowanie rurociągów",
        orbital: "Czat — Axxair / Orbitec / Orbitalum",
        tig: "Czat — technika TIG, materiały, wady",
        prep: "Czat — prace pomocnicze i przygotowawcze",
        others: "Elektrycy, murarze, rusztowaniarze, malarze — wszyscy rzemieślnicy",
      },
    },
    pricing: {
      title: "Wybierz swój plan",
      sub: "Odblokuj czat społeczności, doradcę AI Sauberino i nowe funkcje.",
      free: "Free", freeDesc: "Kalkulatory + AI (limit)",
      pro: "Pro", proDesc: "Wszystko + społeczność + AI 5 wiadomości/dzień",
      monthly: "Miesięcznie", weekly: "Tygodniowo",
      perMonth: "/mies.", perWeek: "/tyg.", subscribe: "Subskrybuj",
      currentPlan: "Aktywny plan", paid: "Aktywna subskrypcja", until: "Ważne do", mostPopular: "Najpopularniejsze",
    },
    jobs: {
      title: "Oferty pracy", sub: "Ogłoszenia firm · 7 € / 7 dni",
      addBtn: "Dodaj ogłoszenie · 7 €", empty: "Brak ogłoszeń",
      emptySub: "Bądź pierwszy — dodaj swoje ogłoszenie za 7 € i dotrzyj do całej społeczności",
      formTitle: "Dodaj ogłoszenie o pracę", formSub: "7 € · widoczne 7 dni · płatność kartą przez Stripe",
      jobTitle: "Nazwa stanowiska", company: "Firma", location: "Lokalizacja",
      desc: "Opis pracy", contactEmail: "Email kontaktowy", salary: "Wynagrodzenie (opcjonalne)",
      jobType: "Rodzaj zatrudnienia", payBtn: "Przejdź do płatności 7 €",
    },
    profile: { editName: "Zapisz imię", changePw: "Zmień hasło", oldPw: "Aktualne hasło", newPw: "Nowe hasło", billingCard: "Dane do faktury", billingFill: "Wypełnij", billingEdit: "Edytuj", upgradeCta: "Aktywuj Pro", avatar: "Zdjęcie profilowe", avatarUpload: "Wgraj awatar", avatarRemove: "Usuń", avatarChange: "Zmień awatar" },
    footer: { tag: "Stworzone dla spawaczy. Przez spawaczy." },
        common: {
      compute: "Oblicz", loading: "Ładowanie…", error: "Błąd",
      result: "Wynik", notes: "Uwagi", units: "Jednostki",
      ready: "Gotowe", live: "LIVE", copy: "Kopiuj",
    },
  },
  fr: {
    nav: {
      home: "Accueil", orbital: "Orbital", tig: "TIG", ai: "Conseiller IA",
      community: "Communauté", pricing: "Mon programme",
      login: "Connexion", register: "S'inscrire", logout: "Déconnexion", profile: "Profil",
      pipefitter: "Tuyauteur", jobs: "Emplois", history: "Historique",
    },
    landing: {
      tag: "Pour les soudeurs professionnels",
      title1: "Précision pour", title2: "soudeurs TIG & orbitaux",
      sub: "Calculateurs de paramètres, conseiller IA et communauté de tuyauteurs, ajusteurs et tous ceux qui veulent partager leur expérience — tout en un seul endroit.",
      cta: "Essayer gratuitement", ctaSecondary: "Vois ce que je peux faire",
      f1Title: "Calculateurs orbitaux", f1Desc: "Paramètres précis pour Axxair, Orbitec et Orbitalum — courant, vitesse, gaz, temps.",
      f2Title: "TIG manuel", f2Desc: "Calcul des réglages pour inox, acier, alu, titane, cuivre, duplex.",
      f3Title: "Conseiller IA", f3Desc: "Claude Sonnet 4.5 — pose des questions sur défauts, normes, procédures. Il se souvient de la conversation.",
      f4Title: "Communauté", f4Desc: "Chat pour abonnés : TIG, orbital, tuyauteurs, ajusteurs.",
      statsTitle: "Conçu pour le terrain",
      stat1: "Matériaux", stat1v: "6+", stat2: "Machines", stat2v: "3",
      stat3: "Canaux", stat3v: "4", stat4: "Précision", stat4v: "±5 %",
      sectionWho: "À qui s'adresse Tigik",
      personas: ["Soudeurs TIG", "Opérateurs orbitaux", "Tuyauteurs", "Ajusteurs"],
    },
    auth: {
      loginTitle: "Connexion", registerTitle: "Créer un compte",
      email: "Email", password: "Mot de passe", name: "Nom",
      submitLogin: "Se connecter", submitRegister: "S'inscrire",
      noAccount: "Pas encore de compte ?", hasAccount: "Déjà un compte ?",
      orbital: "Rejoindre la communauté",
    },
    orbital: {
      title: "Soudage orbital — Calculateur", sub: "Axxair · Orbitec · Orbitalum",
      machine: "Machine", material: "Matériau",
      diameter: "Diamètre tube (mm)", wall: "Épaisseur paroi (mm)",
      compute: "Calculer les paramètres",
      current: "Courant de base", speed: "Vitesse d'avance", time: "Temps de soudure", rotations: "Rotations",
      gas: "Gaz de protection", gasFlow: "Débit de gaz", purge: "Purge envers",
      tungsten: "Électrode tungstène", levels: "Niveaux séquentiels",
      level: "Niveau", currentA: "Courant (A)", pulseT: "Pulse (s)", baseT: "Base (s)",
      waitingCompute: "En attente de calcul…",
      highCurrent: "Courant haut", lowCurrent: "Courant bas",
      pulse: "Pulse", base: "Base", sectorTime: "Temps secteur",
      travel: "Vitesse", gasPurge: "Gaz / Pur.",
      downSlope: "Down-slope", gasPre: "Pré-gaz", gasPost: "Post-gaz",
      exactMatch: "✓ correspondance exacte", interpolated: "≈ interpolé",
      confidence: "Fiabilité", sectorsLabel: "secteurs",
      fieldTitle: "Programmes terrain des utilisateurs",
      fieldDesc: "Programmes ajoutés par les utilisateurs depuis le terrain. Le lookup sélectionne le programme le plus proche selon DN + épaisseur et le redimensionne si besoin.",
      fieldCta: "Trouver un programme terrain", fieldSearching: "Recherche…",
    },
    realprog: {
      title: "Programmes terrain",
      sub: "Programmes de soudures réelles — par la communauté, pour la communauté",
      addBtn: "Ajouter mon programme",
      formTitle: "Ajouter un programme terrain",
      formSub: "Partage les réglages qui marchent vraiment pour toi. Tu aideras les autres soudeurs.",
      materialLbl: "Matériau (ex. Inox 316L, Duplex, Inconel 625)",
      machineLbl: "Machine (ex. Axxair SX-203, Orbitec 84, Orbitalum OW 38)",
      headLbl: "Type de tête (ex. OW 76, OBA 38, SATF-65)",
      jointLbl: "Type de joint",
      jointTypes: { pipePipe: "Tube–Tube", pipeElbow: "Tube–Coude", pipeT: "Tube–Té", pipeReduction: "Tube–Réduction", other: "Autre" },
      dnLbl: "Diamètre (mm)", wallLbl: "Épaisseur paroi (mm)",
      paramsLbl: "Paramètres (tous secteurs — texte multi-lignes)",
      paramsPh: "Ex.\nSecteur 1 : HIGH 95A · LOW 45A · hi 0.25s · lo 0.30s\nSecteur 2 : HIGH 90A · LOW 42A · hi 0.25s · lo 0.30s\n…",
      notesLbl: "Note (optionnel)",
      notesPh: "Ex. gaz Ar 99.996, vitesse 105 mm/min, préchauffage 50 °C…",
      submit: "Enregistrer programme", cancel: "Annuler", saving: "Enregistrement…",
      del: "Supprimer", delConfirm: "Vraiment supprimer ce programme ? Cette action est irréversible.",
      empty: "Aucun programme pour l'instant. Sois le premier à partager tes réglages.",
      addedBy: "Ajouté par", addedAt: "Ajouté le",
      paywallTitle: "Programmes terrain — pour membres payants",
      paywallMsg: "Pour accéder aux programmes partagés et ajouter les tiens, tu as besoin d'un abonnement actif (START / ACTIVE / PRO).",
      guestMsg: "Pour accéder aux programmes terrain, inscris-toi d'abord et active un abonnement.",
      filterTitle: "Filtres",
      filterMaterialPh: "Matériau…", filterHeadPh: "Type de tête…",
      filterDnMin: "DN de", filterDnMax: "DN à",
      clearFilters: "Effacer filtres",
      countLabel: "programmes",
      requiredErr: "Remplis tous les champs obligatoires",
      sortNew: "Plus récents", sortTop: "Meilleurs",
      upvoteTip: "Ça m'a vraiment servi", upvotedTip: "Annuler le vote",
    },
    tig: {
      title: "TIG manuel — Calculateur de paramètres", sub: "Réglage précis pour différents matériaux",
      material: "Matériau", thickness: "Épaisseur (mm)", electrode: "Diamètre électrode (mm)",
      compute: "Calculer",
      currentRange: "Plage de courant", polarity: "Polarité", gas: "Gaz", gasFlow: "Débit de gaz",
      filler: "Métal d'apport", fillerDiam: "Diamètre baguette", electrodeType: "Type d'électrode", preheat: "Préchauffage",
    },
    ai: {
      title: "Conseiller IA", sub: "Claude Sonnet 4.5 — se souvient de la conversation",
      placeholder: "Pose n'importe quelle question sur le soudage…",
      send: "Envoyer", newChat: "Nouvelle conversation", history: "Historique",
      empty: "Commence une nouvelle conversation", thinking: "Réflexion…",
      suggestions: [
        "Quel courant régler pour une soudure TIG inox 316 épaisseur 2 mm ?",
        "Comment éviter la porosité en soudant l'alu ?",
        "Procédure pour soudure orbitale tube 50×2 mm",
        "Défauts fréquents lors d'une passe racine TIG",
      ],
    },
    chat: {
      title: "Chat communauté", sub: "Réservé aux abonnés",
      channels: "Canaux", placeholder: "Écris un message…", send: "Envoyer",
      paywallTitle: "Accès réservé aux abonnés",
      paywallSub: "Active Tigik Pro et accède au chat communauté.",
      paywallCta: "Voir les formules",
      newsReadOnly: "Lecture seule — seul Sauberino(Admin) poste des annonces. Tu recevras automatiquement une notification push.",
      adminOnlyLabel: "ADMIN ONLY",
      channelNames: {
        news: "Tigik News",
        pipefitters: "Tuyauteurs",
        orbital: "Soudeurs orbitaux",
        tig: "TIG manuel",
        prep: "Ajusteurs",
        others: "Autres métiers",
      },
      channelDescs: {
        news: "Annonces de Sauberino — seul l'admin poste, tous reçoivent une notification push",
        pipefitters: "Chat — montage et préparation tuyauterie",
        orbital: "Chat — Axxair / Orbitec / Orbitalum",
        tig: "Chat — technique TIG, matériaux, défauts",
        prep: "Chat — travaux auxiliaires et préparation",
        others: "Électriciens, maçons, échafaudeurs, peintres — tous les artisans",
      },
    },
    pricing: {
      title: "Choisis ta formule",
      sub: "Débloque le chat communauté, conversations IA 5 messages/jours et nouvelles fonctionnalités.",
      free: "Free", freeDesc: "Calculateurs + IA (limite)",
      pro: "Pro", proDesc: "Tout + communauté + IA 5 messages/jour",
      monthly: "Mensuel", weekly: "Hebdo",
      perMonth: "/mois", perWeek: "/sem.", subscribe: "S'abonner",
      currentPlan: "Formule active", paid: "Abonnement actif", until: "Valide jusqu'au", mostPopular: "Plus populaire",
    },
    jobs: {
      title: "Offres d'emploi", sub: "Annonces des entreprises · 7 € / 7 jours",
      addBtn: "Ajouter annonce · 7 €", empty: "Aucune annonce pour le moment",
      emptySub: "Sois le premier — ajoute ton annonce pour 7 € et touche toute la communauté",
      formTitle: "Ajouter une annonce d'emploi", formSub: "7 € · visible 7 jours · paiement par carte via Stripe",
      jobTitle: "Titre du poste", company: "Entreprise", location: "Localisation",
      desc: "Description du poste", contactEmail: "Email de contact", salary: "Salaire (optionnel)",
      jobType: "Type de contrat", payBtn: "Continuer vers paiement 7 €",
    },
    profile: { editName: "Enregistrer nom", changePw: "Changer mot de passe", oldPw: "Mot de passe actuel", newPw: "Nouveau mot de passe", billingCard: "Infos de facturation", billingFill: "Remplir", billingEdit: "Modifier", upgradeCta: "Activer Pro", avatar: "Photo de profil", avatarUpload: "Télécharger avatar", avatarRemove: "Supprimer", avatarChange: "Changer avatar" },
    footer: { tag: "Built for welders. By welders." },
    common: {
      compute: "Calculer", loading: "Chargement…", error: "Erreur",
      result: "Résultat", notes: "Notes", units: "Unités",
      ready: "Prêt", live: "LIVE", copy: "Copier",
    },
  },
};

// Materials with all 7 languages (fallback handled by helper below)
export const MATERIALS_ORBITAL = [
  { id: "stainless_304", sk: "Nerez 304", en: "Stainless 304", cs: "Nerez 304", de: "Edelstahl 304", pl: "Nierdzewna 304" },
  { id: "stainless_316", sk: "Nerez 316", en: "Stainless 316", cs: "Nerez 316", de: "Edelstahl 316", pl: "Nierdzewna 316" },
  { id: "carbon_steel", sk: "Uhlíková oceľ", en: "Carbon steel", cs: "Uhlíková ocel", de: "Kohlenstoffstahl", pl: "Stal węglowa" },
  { id: "duplex", sk: "Duplex", en: "Duplex", cs: "Duplex", de: "Duplex", pl: "Duplex" },
  { id: "inconel", sk: "Inconel", en: "Inconel", cs: "Inconel", de: "Inconel", pl: "Inconel" },
  { id: "titanium", sk: "Titán", en: "Titanium", cs: "Titan", de: "Titan", pl: "Tytan" },
];

export const MATERIALS_TIG = [
  { id: "stainless", sk: "Nerez", en: "Stainless", cs: "Nerez", de: "Edelstahl", pl: "Nierdzewna" },
  { id: "carbon_steel", sk: "Uhlíková oceľ", en: "Carbon steel", cs: "Uhlíková ocel", de: "Kohlenstoffstahl", pl: "Stal węglowa" },
  { id: "aluminum", sk: "Hliník", en: "Aluminum", cs: "Hliník", de: "Aluminium", pl: "Aluminium" },
  { id: "titanium", sk: "Titán", en: "Titanium", cs: "Titan", de: "Titan", pl: "Tytan" },
  { id: "copper", sk: "Meď", en: "Copper", cs: "Měď", de: "Kupfer", pl: "Miedź" },
  { id: "duplex", sk: "Duplex", en: "Duplex", cs: "Duplex", de: "Duplex", pl: "Duplex" },
];

export const MACHINES = [
  { id: "axxair", name: "Axxair" },
  { id: "orbitec", name: "Orbitec" },
  { id: "orbitalum", name: "Orbitalum" },
];
